import { createFileRoute, redirect } from "@tanstack/react-router";

/** Catch-all redirect for retired per-cohort analytics URLs (/analytics/elite-tendon-knee,
 * /analytics/all-diaries, /analytics/general, ...). Cohorts are now label filters on views
 * inside the single /analytics page, so old shared links land there. */
export const Route = createFileRoute("/_app/analytics/$diaryLabel")({
    beforeLoad: () => {
        throw redirect({ to: "/analytics" });
    },
});
